import Model from '@/models/Model'

export default class SlServiceOrder extends Model {
    resource() {
        return 'sl_service_order'
    }
}